import { campaignQueryKeys } from "./queries/queryKeys"


export function invalidateCampaigns(queryClient, network) {
    const queryKey = [...campaignQueryKeys["detail"](), { network: network?.slug }]
    queryClient.invalidateQueries({
        queryKey: queryKey,
    })
}

export function invalidateCampaignsList(queryClient, network) {
    const queryKey = [...campaignQueryKeys["list"](), { network: network?.slug }]
    queryClient.invalidateQueries({
        queryKey: queryKey,
    })
}